(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sd-bb-stock-guarantee"] && !Shopify.designMode) return;
  try {
    /*
    Wisselt de vlag naar het land van de bezoeker.

    Staat in het javascript-blok en niet in een script-tag in de markup: de koopkolom
    wordt bij een variantwissel opnieuw getekend, en een script dat zo binnenkomt
    voert nooit uit. Dit bestand laadt één keer per pagina, en de observer vangt
    elke opnieuw getekende vlag op.

    Het land komt uit Shopify's eigen endpoint en wordt per sessie onthouden, dus
    er gaat hooguit één extra verzoek per bezoek uit.
  */
  (() => {
    if (window.__sdVisitorFlag) return;
    window.__sdVisitorFlag = true;
    const SLEUTEL = 'sd:visitor-country';

    const pasToe = (land) => {
      document.querySelectorAll('img[data-sd-visitor-flag]').forEach((img) => {
        if (img.dataset.sdFlagDone === (land || '-')) return;
        img.dataset.sdFlagDone = land || '-';
        if (!land) return;
        img.src = 'https://cdn.shopify.com/static/images/flags/' + land.toLowerCase() + '.svg';
        img.alt = land;
      });
    };

    const haalLand = () => {
      try {
        const bewaard = sessionStorage.getItem(SLEUTEL);
        if (bewaard !== null) return Promise.resolve(bewaard);
      } catch (e) { /* geen opslag, gewoon opvragen */ }
      return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((j) => {
          const land = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
          try { sessionStorage.setItem(SLEUTEL, land); } catch (e) { /* niet erg */ }
          return land;
        })
        .catch(() => '');
    };

    haalLand().then((land) => {
      pasToe(land);
      let gepland = false;
      new MutationObserver(() => {
        if (gepland) return;
        gepland = true;
        requestAnimationFrame(() => { gepland = false; pasToe(land); });
      }).observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
